module.exports = __webpack_public_path__ + "img/link.1a3affe9.svg";